import {
  SET_UPDATING_LISTING_ID,
  UPDATE_PINNED_LISTINGS,
  CLEARING_LISTINGS,
  UPDATE_SEARCH_TEXT,
  UPDATE_SEARCH_RESULTS
} from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
  case SET_UPDATING_LISTING_ID: {
    return { ...state, updatingListingId: action.payload.id };
  }
  case CLEARING_LISTINGS: {
    return { ...state, clearing: true };
  }
  case UPDATE_PINNED_LISTINGS: {
    return { ...state, updatingListingId: null, clearing: false };
  }
  case UPDATE_SEARCH_TEXT: {
    return { ...state, searchText: action.payload.searchText, waiting: true };
  }
  case UPDATE_SEARCH_RESULTS: {
    return { ...state, waiting: false };
  }
  }
  return state;
}
